import PlotsById from './PlotsById';

export default PlotsById;
